import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6aacce7c")

_pushScopeId("data-v-6aacce7c")
const _hoisted_1 = {
  key: 1,
  class: "funteamclues__game flex justify-center"
}
const _hoisted_2 = { class: "flex flex-column items-center funteamclues__content" }
const _hoisted_3 = {
  key: 1,
  class: "flex funteamclues__game-finished"
}
const _hoisted_4 = { class: "mr1" }
const _hoisted_5 = { class: "flex flex-column justify-center funteamclues__phase" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LanguageSelection = _resolveComponent("LanguageSelection")!
  const _component_GameLogout = _resolveComponent("GameLogout")!
  const _component_IconAttribute = _resolveComponent("IconAttribute")!
  const _component_SoundMuting = _resolveComponent("SoundMuting")!
  const _component_LogoSpinner = _resolveComponent("LogoSpinner")!
  const _component_FunTeamCluesJoinGame = _resolveComponent("FunTeamCluesJoinGame")!
  const _component_PeopleStillJoining = _resolveComponent("PeopleStillJoining")!
  const _component_FunTeamCluesPhaseNav = _resolveComponent("FunTeamCluesPhaseNav")!
  const _component_Button = _resolveComponent("Button")!
  const _component_PhaseWelcome = _resolveComponent("PhaseWelcome")!
  const _component_FunTeamCluesBoard = _resolveComponent("FunTeamCluesBoard")!
  const _component_FunTeamCluesInstructionGuy = _resolveComponent("FunTeamCluesInstructionGuy")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_LanguageSelection, { class: "funteamclues__language" }),
    _createVNode("div", {
      class: ["funteamclues__options", { 'funteamclues__options--visible': _ctx.optionsVisible }]
    }, [
      _createVNode(_component_GameLogout, { class: "my2" })
    ], 2),
    _createVNode(_component_IconAttribute, { white: true }),
    _createVNode(_component_SoundMuting, { class: "funteamclues__sound" }),
    (_ctx.gameLoading)
      ? (_openBlock(), _createBlock(_component_LogoSpinner, { key: 0 }))
      : (_openBlock(), _createBlock("div", _hoisted_1, [
          (_ctx.currentGame && _ctx.showJoinGame)
            ? (_openBlock(), _createBlock(_component_FunTeamCluesJoinGame, {
                key: 0,
                "join-loading": _ctx.joinLoading,
                players: _ctx.currentGame.players,
                onJoin: _ctx.handleJoinGame
              }, null, 8, ["join-loading", "players", "onJoin"]))
            : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                (_ctx.currentPlayer?.admin && _ctx.currentGame.phase === 'WELCOME')
                  ? (_openBlock(), _createBlock(_component_PeopleStillJoining, {
                      key: 0,
                      teams: _ctx.currentGame.teams,
                      players: _ctx.currentGame.players
                    }, null, 8, ["teams", "players"]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_2, [
                  (_ctx.currentGame.phase !== 'WELCOME' && !_ctx.currentGame.gameEnded)
                    ? (_openBlock(), _createBlock(_component_FunTeamCluesPhaseNav, {
                        key: 0,
                        phase: _ctx.currentGame.phase,
                        "active-team-name": _ctx.currentGame.activeTeamName,
                        "spy-name": _ctx.spyFromCurrentTeam?.name,
                        class: "funteamclues__phase-nav"
                      }, null, 8, ["phase", "active-team-name", "spy-name"]))
                    : _createCommentVNode("", true),
                  (_ctx.currentGame.gameEnded)
                    ? (_openBlock(), _createBlock("div", _hoisted_3, [
                        _createVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('funTeamClues.gameEnded', { team: _ctx.currentGame.endResults?.winningTeamName.name })), 1),
                        (_ctx.currentPlayer.admin)
                          ? (_openBlock(), _createBlock(_component_Button, {
                              key: 0,
                              onClick: _ctx.startNewGame
                            }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('common.startNewGame')), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_5, [
                    _createVNode(_component_FunTeamCluesBoard, { game: _ctx.currentGame }, {
                      default: _withId(() => [
                        _createVNode(_component_PhaseWelcome, {
                          class: "funteamclues__phase-welcome",
                          game: _ctx.currentGame,
                          "start-game": _ctx.startGame,
                          "cancel-game": _ctx.cancelGame,
                          "show-start-game-button": _ctx.showStartGameButton,
                          instructions: _ctx.instructions
                        }, null, 8, ["game", "start-game", "cancel-game", "show-start-game-button", "instructions"])
                      ]),
                      _: 1
                    }, 8, ["game"])
                  ])
                ]),
                _createVNode(_component_FunTeamCluesInstructionGuy, {
                  class: "funteamclues__instruction-guy",
                  phase: _ctx.currentGame.phase
                }, null, 8, ["phase"])
              ], 64))
        ]))
  ], 64))
})